<template>
  <div class="order">
    <form novalidate="novalidate" class="simple_form new_order_form">
      <div class="row">
        <div class="col-sm-12 col-md-8">
          <div class="form-row">
            <input class="numeric integer optional form-control order-limit"
                   :placeholder="I18n.t('orders.placeholder')" min="100" step="100"
                   type="number" v-model="userOrder.limit" />
          </div>
        </div>
      </div>
      <div class="form-row additional-options">
        <a class="link-collapse collapsed headings--h4"
           role="button"
           data-toggle="collapse"
           href="#additionalOptions"
           aria-expanded="false"
           aria-controls="additionalOptions">
          {{ I18n.t("orders.additional_options") }}
          <span class="icon icon-arrow-top"></span>
          <span class="icon icon-arrow-bottom"></span>
        </a>
      </div>
      <div class="collapse order-additional-options" id="additionalOptions">
        <input id="one_more_bid"
               class="boolean optional"
               type="checkbox" value="true"
               v-model="userOrder.oneMoreBid">
        <label for="one_more_bid">
          {{ I18n.t("simple_form.labels.order_form.one_more_bid") }}
          <b-btn v-b-tooltip.hover
                 :title="I18n.t('orders.bid_info')"
                 class="btn-link link--orange global-search__tooltip order-form__tooltip">
            <abbr data-original-title="" class="position-relative abbr"></abbr>
          </b-btn>
        </label>
        <br>
        <input id="contact"
               class="boolean optional form-checkbox phone-checkbox"
               type="checkbox" value="true"
               v-model="orderWithPhone">
        <label for="contact">
          {{ I18n.t("orders.phone") }}
          <b-btn v-b-tooltip.hover
                 :title="I18n.t('orders.abbr')"
                 class="btn-link link--orange global-search__tooltip order-form__tooltip">
            <abbr data-original-title="" class="position-relative abbr"></abbr>
          </b-btn>
        </label>
        <div class="modal-fade" :class="{ 'show' : orderWithPhone }">
          <input id="order_form_phone"
                 :class="{ 'has-content' : order.phone }"
                 class="string tel optional form-input"
                 type="number"
                 v-model="userOrder.phone">
          <label class="tel optional" for="order_form_phone">
            {{ I18n.t("orders.phone") }}
          </label>
        </div>
        <div class="form-input-row">
          <input id="order_form_note"
                 :class="{ 'has-content' : order.note }"
                 class="string optional form-input"
                 type="text"
                 v-model="userOrder.note">
          <label class="string optional" for="order_form_note">
            {{ I18n.t("orders.note") }}
          </label>
        </div>
      </div>
    </form>
    <div class="row">
      <div class="col-sm-8">
        <div class="form-row">
          <button @click="sendOrder()" class="btn btn--block btn__primary GTM__order--submit">
            {{ I18n.t("simple_form.labels.order_form.submit") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';

  export default {
    name: 'OrderForm',
    props: {
      order: {
        type: Object,
        default: () => ({
          limit: '',
          phone: '',
          note: '',
          oneMoreBid: false,
        }),
      },
      artwork: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        orderWithPhone: this.order.phone !== '',
        userOrder: {
          limit: this.order.limit,
          oneMoreBid: this.order.oneMoreBid,
          phone: this.order.phone,
          note: this.order.note,
          type: 'orders',
          artwork_id: this.artwork.id,
        },
      };
    },
    computed: {
      ...mapGetters(['currentArtworkIndex']),
    },
    methods: {
      ...mapActions(['updateOrder', 'createOrder']),
      sendOrder() {
        if (!this.orderWithPhone) this.userOrder.phone = '';
        if (this.order.limit || this.order.phone) {
          this.updateOrder(
            { id: this.order.id, value: this.userOrder, index: this.currentArtworkIndex })
            .then(this.checkResponse);
        } else {
          this.createOrder(
            { value: this.userOrder, index: this.currentArtworkIndex })
            .then(this.checkResponse);
        }
      },
      checkResponse(response) {
        if (response.status === 200) {
          this.$emit('showResponse', response);
        } else {
          this.$emit('showResponse', response.body.errors[0].detail);
        }
        if (this.userOrder.phone === '') this.orderWithPhone = false;
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/modal/orders/order_form.vue?4773f93a